import { render, staticRenderFns } from "./ListaEnderecoPessoa.vue?vue&type=template&id=6af7b3e4"
import script from "./ListaEnderecoPessoa.vue?vue&type=script&lang=js"
export * from "./ListaEnderecoPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports